// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__fYxeA","emails":"CreateEditClinics_emails__1HFI_","emailTagLabel":"CreateEditClinics_emailTagLabel__8LU0n"};